import { render, staticRenderFns } from "./PendingRequests.vue?vue&type=template&id=4e538c97&scoped=true&"
import script from "./PendingRequests.vue?vue&type=script&lang=js&"
export * from "./PendingRequests.vue?vue&type=script&lang=js&"
import style0 from "./PendingRequests.vue?vue&type=style&index=0&id=4e538c97&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e538c97",
  null
  
)

export default component.exports